import React, { useState } from "react";

import Navbar from '../navbar/navbar'
import { Layout, Menu, Typography } from 'antd';

import {
    ScheduleOutlined,
    TeamOutlined,
    LogoutOutlined,
    SettingOutlined,
    FieldTimeOutlined,
    FileTextOutlined,
    EnvironmentOutlined,
    ControlOutlined
} from '@ant-design/icons';
import { BusinessOutlined } from "@material-ui/icons";

import { Link, useLocation } from "react-router-dom";
import { AuthConsumer } from "../../../main/authenticationProvider";
import StorageService from "../../../app/service/storageService";
const { Header, Content, Sider, Footer } = Layout;


const MgmtLayout = (props) => {
    const location = useLocation();
    const [activeKey, setActiveKey] = useState(location.pathname.substring(6));
    const [openKeys, setOpenKeys] = useState(StorageService.getItem("subMenuOpen") === "reports" ? "reports" : "");

    const handleOpenAndCloseSubMenu = (e) => {
        const value = StorageService.getItem("subMenuOpen");
        if (value === null || value === undefined || value === "") {
            StorageService.addItem("subMenuOpen", e.key);
            setOpenKeys(e.key);
        } else {
            StorageService.addItem("subMenuOpen", "");
            setOpenKeys("");
        }
    }

    const menuItems = [
        {
            label: <Link to="/mgmt/clients" children="Clientes" />,
            key: 'clients',
            icon: <BusinessOutlined style={{ fontSize: '18px' }} />,
        },
        {
            label: <Link to="/mgmt/logins" children="Logins" />,
            key: 'logins',
            icon: <TeamOutlined />,
        },
        {
            label: <Link to="/mgmt/plates" children="Placas" />,
            key: 'plates',
            icon: <ScheduleOutlined />,
        },
        {
            label: <Link to="/mgmt/settinghorimeter" children="Config. Horímetro" />,
            key: 'settinghorimeter',
            icon: <SettingOutlined />,
        },
        {
            label: 'Relatórios',
            key: 'reports',
            icon: <FileTextOutlined style={{ color: 'white' }} />,
            onTitleClick: (e) => handleOpenAndCloseSubMenu(e),
            children: [
                {
                    label: <Link to="/mgmt/positions" children="Posições" />,
                    key: 'positions',
                    icon: <EnvironmentOutlined />,
                },
                {
                    label: <Link to="/mgmt/horimeter" children="Horímetro" />,
                    key: 'horimeter',
                    icon: <FieldTimeOutlined />,
                },
                {
                    label: <Link to="/mgmt/commands" children="Comandos" />,
                    key: 'command',
                    icon: <ControlOutlined />,
                },
            ]
        },
        {
            label: <Link
                onClick={props.out}
                to="/login"
                children="Sair"
            />,
            key: 'logout',
            icon: <LogoutOutlined />,
        },
    ]
    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Header style={{ backgroundColor: "black", zIndex: 100 }}>
                <Navbar landingPage='/mgmt' isUserAuthenticated={props.isUserAuthenticated} out={props.out} />
            </Header>
            {props.isUserAuthenticated ? (
                <>
                    <Layout>
                        <Sider
                            breakpoint="lg"
                            collapsedWidth="0"
                            style={{
                                overflow: 'auto',
                                height: '100vh',
                                position: 'fixed',
                                top: 0
                            }}
                        >
                            <Menu
                                selectedKeys={activeKey}
                                openKeys={openKeys}
                                onOpenChange={e => setOpenKeys([...e])}
                                defaultOpenKeys='everlinkAdmin'
                                theme="dark"
                                mode="inline"
                                inlineIndent={15}
                                style={{ borderRight: 0, width: '100%', marginTop: '70px' }}
                                items={menuItems}
                            >
                            </Menu>
                        </Sider>
                        <Layout
                            style={{
                                marginLeft: 200,
                            }}
                        >
                            <Content style={{ padding: '12px' }}>
                                {props.children}
                            </Content>
                        </Layout>

                    </Layout>
                    <Footer

                        style={{
                            textAlign: 'center',
                            height: '20px',
                        }}
                    >
                        <Typography style={{ fontWeight: 500 }}>Rota Track Copyright ©{new Date().getFullYear()}</Typography>
                    </Footer>
                </>
            ) : (
                <Content className={props.className}>
                    {props.children}
                </Content>
            )}
        </Layout>
    );
}

export default (props) => (
    <AuthConsumer>
        {(context) => (
            <MgmtLayout className={props.className} isUserAuthenticated={context.isAuthenticated} out={context.endSession} children={props.children} />
        )}
    </AuthConsumer>
)